/* eslint-disable react/prop-types */
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Divider, Stack, Typography, styled } from '@mui/material';
import { useState } from 'react';
import { GoogleBannerAds } from '../../components/GoogleAds';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Iconify from '../../components/Iconify';
import Image from '../../components/Image';
import sign1 from "../../data/mapping-json/sign1.json";
import sign2 from "../../data/mapping-json/sign2.json";
import sign3 from "../../data/mapping-json/sign3.json";
import sign4 from "../../data/mapping-json/sign4.json";
import sign5 from "../../data/mapping-json/sign5.json";
import sign6 from "../../data/mapping-json/sign6.json";
import useLocales from '../../hooks/useLocales';
import useSettings from '../../hooks/useSettings';
import Layout from '../../layouts';
import { PATH_THIGPLX } from '../../routes/paths';

const data = [
  {
    id: 1,
    title: `[${sign1.length}] BIỂN BÁO CẤM`,
    listSigns: sign1,
  },
  {
    id: 2,
    title: `[${sign2.length}] BIỂN NGUY HIỂM`,
    listSigns: sign2
  },
  {
    id: 3,
    title: `[${sign3.length}] BIỂN BÁO HIỆU LỆNH`,
    listSigns: sign3
  },
  {
    id: 4,
    title: `[${sign4.length}] BIỂN BÁO CHỈ DẪN`,
    listSigns: sign4
  },
  {
    id: 5,
    title: `[${sign5.length}] BIỂN BÁO PHỤ`,
    listSigns: sign5
  },
  {
    id: 6,
    title: `[${sign6.length}] BIỂN BÁO VẠCH CHỈ DẪN`,
    listSigns: sign6
  }
];

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
  },
  paddingBottom: theme.spacing(10),
}));

TrafficSigns.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function TrafficSigns() {
  const [index, setIndex] = useState(1);
  const { themeStretch } = useSettings();
  const { translate } = useLocales();

  const handleSelect = (value) => (_, newExpanded) => {
    setIndex(newExpanded ? value : false);
  };

  const breadcrumbLinks = [
    { name: translate('menu.home'), href: PATH_THIGPLX.home },
    { name: translate('sign.title') }
  ];

  return (
    <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
      <RootStyle>
        <Stack spacing={3}>
          <HeaderBreadcrumbs
            heading={translate('sign.title')}
            links={breadcrumbLinks}
          />
          <GoogleBannerAds />
          <Stack>
            {data.map((item) => (
              <Group key={item.id} groupSign={item} index={index} handleSelect={handleSelect} />
            ))}
          </Stack>
          <GoogleBannerAds />
        </Stack>
      </RootStyle>
    </Container >
  );
}

const Group = ({ groupSign, index, handleSelect }) => (
  <Accordion expanded={index === groupSign.id} onChange={handleSelect(groupSign.id)} variant='outlined'>
    <AccordionSummary expandIcon={<Iconify icon={"material-symbols:expand-more"} />}>
      <Typography variant='subtitle1'>{groupSign.title}</Typography>
    </AccordionSummary>
    <Divider variant="fullWidth" />
    <AccordionDetails>
      {groupSign.listSigns.map((item, idx) => (
        <Sign sign={item} key={idx} />
      ))}
    </AccordionDetails>
  </Accordion>
);

function Sign({ sign }) {
  return (
    <>
      <Stack direction={"row"} p={2} alignItems={"center"}>
        <Box sx={{ minWidth: 120, maxWidth: 120 }} >
          <Image alt="sign" src={`/signs/sign${sign.img}.png`} />
        </Box>
        <Stack ml={5}>
          <Typography variant='subtitle1'>{sign.id}</Typography>
          <Typography variant='subtitle1'>{sign.name}</Typography>
          <Typography variant='body1'>{sign.detail}</Typography>
        </Stack>
      </Stack>
      <Divider variant="fullWidth" />
    </>
  );
}